import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import useTableSorting from "../../../hooks/useTableSorting";
import { createSortableColumns } from "./PTReportsColumns";
import moment from "moment";
import { fetchPTReportsData } from "../../../redux/reducers/apiSlice";
import PTTableFilters from "../common/PTTableFilters";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import UserProfile from "../UserProfile";
import {
  formatDateTimezon,
  convertStraight,
  convertThenFormat,
  convertTo12HourFormat,
} from "../../common-data/Converts";
import MemberCheckinLogs from "../common/MemberCheckinLogs";
import ModalHeader from "../../ModalHeader";
import SelectExportables from "../../common-components/SelectExportables";
import {
  commonPostPutApi,
  fetchExportApiData,
} from "../../../redux/reducers/commonApiSlice";
import { ptReports, trial_intro_done } from "../../../data/ApiEndpoints";
import AssignedMembers from "./AssignedMembers";
import WorkoutLogs from "../common/WorkoutLogs";
import PTTableCards from "../mobile-view/PTTableCards";
import { deletePTTrack } from "../../../redux/reducers/deleteApiSlice";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import ReceptionistForm from "../open-tracks/ReceptionistForm";
import PTTrialForm from "../PTTrialForm";
import { exportableData } from "../common/SharedDatas";
import {
  objectToQueryString,
  isManagerRole as checkIsManagerRole,
} from "../../common-data/Conversions";
import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import TrainerSession from "../open-tracks/TrainerSession";
import { FutureSubscriptionButton } from "./re-usablee/FutureSubscriptionButton";
import CommonTable from "../../common-components/common-tables/CommonTable";
import {
  AlertIcon,
  BinIcon,
  CheckCircleIcon,
  ClockIcon,
  DatePickerIcon,
  EditIcon,
  EditIcon1,
  InfoCircleIcon,
  PersonIcon,
  RupeeIcon,
  XCircleIcon,
} from "../../../images/icons/icons";
import InfoPopover from "./re-usablee/InfoPopover";

const PTReports = ({
  decryptedText,
  receptionistInfo,
  isOpen,
  prevFilters,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const token = decryptedText?.token;
  const { ptReportsLoading, ptReportsData, ptReportError } = useSelector(
    (state) => state.api
  );
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";
  const isManagerRole = checkIsManagerRole(decryptedText);

  const iniPTReports = {
    isPage: 0,
    pageLimit: 10,
    allPTReports: [],
    pagination: [],
  };
  const [allPTReportsData, setAllPTReportsData] = useState(iniPTReports);
  const { isPage, pageLimit, allPTReports, pagination } =
    allPTReportsData || {};

  const extractCheckinTimes = (checkinArray) => {
    let last_checkin_start_end_time = [];

    checkinArray?.length > 0 &&
      checkinArray.forEach((item) => {
        const itemValue = item.value;
        last_checkin_start_end_time.push(itemValue);
      });

    return {
      last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
    };
  };
  const [toggle, setToggle] = useState(false);
  const initialFilters = {
    searchString: "",
    selectedGym:
      !isAdmin && !isManagerRole
        ? { label: decryptedText?.gym_name, value: decryptedText?.gym_id }
        : prevFilters?.selectedGym
        ? prevFilters.selectedGym
        : "",
    selectedTrainer: isTrainer
      ? {
          label: decryptedText?.name,
          value: decryptedText?.uid || decryptedText?.user_id,
        }
      : prevFilters.selectedTrainer
      ? prevFilters.selectedTrainer
      : "",
    selectedSubsAddedBy: "",
    selectedReceptionist: "",
    selectedPTTrialStatus: "",
    selectedHandoverStatus: isTrainer
      ? { label: "Handover Completed", value: "handover_completed" }
      : prevFilters.selectedHandoverStatus
      ? prevFilters.selectedHandoverStatus
      : "",
    selectedCard: "",
    handoverCompletedOn: "",
    trialCompletedOn: "",
    lastCheckedIn: "",
    lastWorkoutDaysAgo: "",
    isBiomaxRegister: "",
    isFitnessProfile: "",
    trainerRatingStatus: "",
    selTrainerIntro: "",
    selPTProspect: "",
    selProspectStatus: "",
    selLeastCheckinInBetween: [],
    selBiomaxAppRegister: "",
    selTrialAddedFrom: "",
    selectedPTTrial: "",
    selectedPTTrialStartStatus: "",
    selectedConvertedStatus: "",
    selectedPaymentLocation: "",

    selPtScheduleDateFrom: "",
    selPtScheduleDateTo: "",
    selExpCloserDateFrom: "",
    selExpCloserDateTo: "",
    selPtTrialAssignedDateFrom: "",
    selPtTrialAssignedDateTo: "",
    selPtInitiatedDateFrom: "",
    selPtInitiatedDateTo: "",
    selSubscriptionAddDateFrom: prevFilters?.selSubscriptionAddDateFrom || "",
    selSubscriptionAddDateTo: prevFilters?.selSubscriptionAddDateTo || "",
    bcaReportStatus: "",
    isFutureSubscription: false,
  };
  const [filters, setFilters] = useState(initialFilters);

  const { last_checkin_start_end_time } = extractCheckinTimes(
    filters.selLeastCheckinInBetween
  );
  const [allFilters, setAllFilters] = useState({});
  const iniSendableFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: filters.selectedGym?.value ? filters.selectedGym.value : "",
    assigned_to: filters.selectedTrainer?.value || "",
    sub_added_by: filters.selectedSubsAddedBy?.value || "",
    assigned_by: filters.selectedReceptionist?.value || "",
    trial_status: filters.selectedPTTrialStatus?.value || "",
    prspct_status: filters.selProspectStatus?.value || "",
    handover_status: filters.selectedHandoverStatus?.value || "",
    assigned_date_days_ago: filters.handoverCompletedOn?.value || "",
    pt_initiate_date_days_ago: filters.trialCompletedOn?.value || "",
    last_checkin_days_ago: filters.lastCheckedIn?.value || "",
    last_workout_date_days_ago: filters.lastWorkoutDaysAgo?.value || "",
    is_biomax_registered: filters.isBiomaxRegister?.value || "",
    isfitness_profile_completed: filters.isFitnessProfile?.value || "",
    rating_status: filters.trainerRatingStatus?.value || "",
    trnr_intro_status: filters.selTrainerIntro?.value || "",
    is_pt_prspct: filters.selPTProspect?.value || "",
    last_checkin_time_filter: last_checkin_start_end_time || "",
    biomax_first_step: filters.selBiomaxAppRegister?.value || "",
    added_from: filters.selTrialAddedFrom?.value || "",
    three_day_assigned: filters.selectedPTTrial?.value || "",
    pt_trial_start_status: filters.selectedPTTrialStartStatus?.value || "",
    converted: filters.selectedConvertedStatus?.value || "",
    start_date: filters.selSubscriptionAddDateFrom || "",
    end_date: filters.selSubscriptionAddDateTo || "",
    pt_schedule_start_date: filters.selPtScheduleDateFrom || "",
    pt_schedule_end_date: filters.selPtScheduleDateTo || "",
    expctd_closure_start_date: filters.selExpCloserDateFrom || "",
    expctd_closure_end_date: filters.selExpCloserDateTo || "",
    threeday_assign_from: filters.selPtTrialAssignedDateFrom || "",
    threeday_assign_to: filters.selPtTrialAssignedDateTo || "",
    payment_location: filters.selectedPaymentLocation?.value || "",
    pt_initiated_date_from: filters.selPtInitiatedDateFrom || "",
    pt_initiated_date_to: filters.selPtInitiatedDateTo || "",
    subscription_add_date_from: filters.selSubscriptionAddDateFrom || "",
    subscription_add_date_to: filters.selSubscriptionAddDateTo || "",
    bca_report_status: filters.bcaReportStatus?.value || "",
    three_day_done_count: filters.threeDayDoneCount?.value || "",
    three_day_done_from: filters.selThreeDayDoneDateFrom || "",
    three_day_done_to: filters.selThreeDayDoneDateTo || "",
    is_future_subscription: filters.isFutureSubscription || false,
    future_trial: toggle ? 1 : 0,
  };

  const [sendableFilters, setSendableFilters] = useState(iniSendableFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const initialClickValues = {
    isModOpen: false,
    name: "",

    rowData: "",
    userId: "",
    type: "",
    assignToId: "",
    shiftTime: "",

    viewImage: "",
    userName: "",
    userNo: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [activePopover, setActivePopover] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  const { handleSort, getSortDirection, isFieldSorted, sortedData } =
    useTableSorting(allPTReportsData.allPTReports || []);

  const prevFiltersQP = objectToQueryString(prevFilters);

  const iniAdminInfo = {
    name: decryptedText?.name || "",
    mobile: decryptedText?.mobile || "",
    email: decryptedText?.email || "",
    user_id: decryptedText?.uid || decryptedText?.user_id || "",
    gym_id: decryptedText?.gym_id || "",
    gym_name: decryptedText?.gym_name || "",
    account_type: decryptedText?.account_type || "",
  };

  const handleToggle = () => {
    setToggle((prev) => !prev);
  };

  const handleInfoClick = (rowData, popoverType, event) => {
    if (event) {
      event.stopPropagation();
    }
    const popoverId = `${rowData.uid}-${popoverType}`;
    setActivePopover(activePopover === popoverId ? null : popoverId);
  };

  const onClickReset = () => {
    setFilters(initialFilters);
    setAllPTReportsData((prevs) => ({ ...prevs, isPage: 0 }));
    setToggle(false);
  };

  const onClickSearch = () => {
    if (filters.searchString) {
      setSendableFilters((prevs) => ({
        ...prevs,
        search: filters.searchString,
      }));
      setSearchFilterApplied(true);
      setAllPTReportsData((prevs) => ({ ...prevs, isPage: 0 }));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const onCloseModal = (name) => {
    setClickValues(initialClickValues);
  };

  const onClickExport = (filters) => {
    if (filters.is_export) {
      dispatch(
        fetchExportApiData({
          method: "GET",
          endpoint: ptReports,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  };

  const handleDelete = async (e, uid) => {
    e.preventDefault();

    const handleConfirm = async () => {
      if (uid) {
        try {
          const response = await dispatch(
            deletePTTrack({
              TOKEN: decryptedText?.token,
              UID: uid,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getPtReportsData(sendableFilters);
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
  };

  const onClickBtns = (e, name, rowData) => {
    e.preventDefault();

    setClickValues({
      ...clickValues,
      name: name,
      isModOpen: true,
      rowData: rowData,
      trainerDetails: {
        mobile: rowData?.assigned_to_mobile,
        name: rowData?.assigned_to_name,
        gym_name: rowData?.gym_name,
        gym_id: rowData?.gym_id,
        user_id: rowData?.assigned_to,
        email: rowData?.assigned_to_email,
      },
    });
  };

  function getPtReportsData(sendableFilters) {
    const { page, limit, ...rest } = sendableFilters;

    const filteredParams = Object.entries(rest)
      .filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const queryParameters = filteredParams;

    dispatch(
      fetchPTReportsData({
        pageNo: page,
        limit: limit || 10,
        queryParameters: queryParameters,
        token: token,
      })
    );
  }

  const sortableColumns = createSortableColumns({
    handleSort,
    getSortDirection,
    isFieldSorted,
    handleInfoClick,
    setClickValues,
    onClickBtns,
    handleDelete,
    activePopover,
    setActivePopover,
    isTrainer,
    isAdmin,
    isFitnessManager,
    isReceptionist,
  });

  // --------------------
  const handleTrialIntroUpdate = async (requestBody) => {
    const method = "POST";
    const endpoint = trial_intro_done;
    const payload = requestBody;
    const token = decryptedText?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        callFunction();
        getPtReportsData(sendableFilters);
        setSelectedRows([]);
        setIsAllSelected(false);
        setAllPTReportsData((prevState) => ({
          ...prevState,
          allPTReports: prevState.allPTReports.map((lead) => ({
            ...lead,
            checked: false,
          })),
        }));
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function onClickTrialDone() {
    const allTrailsIntros = selectedRows?.map((row) => row?.uid);

    const userData = {
      trial_details: allTrailsIntros,
    };

    const handleConfirm = async () => {
      handleTrialIntroUpdate(userData);
    };

    showConfirmAlert(handleConfirm, `Are You Sure?`);
  }

  const handleToggleAllClick = (event) => {
    const isChecked = event.target.checked;

    const tableData = allPTReports;

    const updatedRows = tableData?.map((row) => {
      if (
        row?.handover_status === "pending" ||
        row?.trnr_intro_status === "completed"
      ) {
        return row;
      }

      return {
        ...row,
        checked: isChecked,
      };
    });

    const selectedRows = isChecked
      ? updatedRows.filter(
          (row) =>
            row?.handover_status !== "pending" &&
            row?.trnr_intro_status !== "completed"
        )
      : [];

    setSelectedRows(selectedRows);
    setIsAllSelected(isChecked);

    setAllPTReportsData((prevState) => ({
      ...prevState,
      allPTReports: updatedRows,
    }));
  };

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;

    const updatedRows = allPTReports?.map((r) =>
      r.uid === row.uid ? { ...r, checked: isChecked } : r
    );

    setSelectedRows(
      isChecked
        ? [...selectedRows, { ...row, checked: isChecked }]
        : selectedRows.filter((selectedRow) => selectedRow.uid !== row.uid)
    );

    setAllPTReportsData((prevState) => ({
      ...prevState,
      allPTReports: updatedRows,
    }));
  };
  // ----------------------------

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isManagerRole
          ? { label: decryptedText?.gym_name, value: decryptedText?.gym_id }
          : prevFilters.selectedGym || "",
      selectedTrainer: isTrainer
        ? {
            label: decryptedText?.name,
            value: decryptedText?.uid || decryptedText?.user_id,
          }
        : prevFilters.selectedTrainer || "",
      selectedHandoverStatus: isTrainer
        ? { label: "Handover Completed", value: "handover_completed" }
        : prevFilters.selectedHandoverStatus || "",
      selSubscriptionAddDateFrom: prevFilters?.selSubscriptionAddDateFrom || "",
      selSubscriptionAddDateTo: prevFilters?.selSubscriptionAddDateTo || "",
    }));
  }, [
    decryptedText?.gym_id,
    decryptedText?.name,
    decryptedText?.uid,
    decryptedText?.user_id,
    isAdmin,
    isTrainer,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const newSendableFilters = {
        limit: pageLimit || 10,
        page: 1,
        gym_id: filters.selectedGym?.value || "",
        assigned_to: filters.selectedTrainer?.value || "",
        sub_added_by: filters.selectedSubsAddedBy?.value || "",
        assigned_by: filters.selectedReceptionist?.value || "",
        trial_status: filters.selectedPTTrialStatus?.value || "",
        prspct_status: filters.selProspectStatus?.value || "",
        handover_status: filters.selectedHandoverStatus?.value || "",
        assigned_date_days_ago: filters.handoverCompletedOn?.value || "",
        pt_initiate_date_days_ago: filters.trialCompletedOn?.value || "",
        last_checkin_days_ago: filters.lastCheckedIn?.value || "",
        last_workout_date_days_ago: filters.lastWorkoutDaysAgo?.value || "",
        is_biomax_registered: filters.isBiomaxRegister?.value || "",
        isfitness_profile_completed: filters.isFitnessProfile?.value || "",
        rating_status: filters.trainerRatingStatus?.value || "",
        trnr_intro_status: filters.selTrainerIntro?.value || "",
        is_pt_prspct: filters.selPTProspect?.value || "",
        last_checkin_time_filter: last_checkin_start_end_time || "",
        biomax_first_step: filters.selBiomaxAppRegister?.value || "",
        added_from: filters.selTrialAddedFrom?.value || "",
        three_day_assigned: filters.selectedPTTrial?.value || "",
        pt_trial_start_status: filters.selectedPTTrialStartStatus?.value || "",
        // trnr_intro_status: filters.selTrainerIntro?.value || "",
        converted: filters.selectedConvertedStatus?.value || "",
        start_date: filters.selSubscriptionAddDateFrom || "",
        end_date: filters.selSubscriptionAddDateTo || "",
        pt_schedule_start_date: filters.selPtScheduleDateFrom || "",
        pt_schedule_end_date: filters.selPtScheduleDateTo || "",
        expctd_closure_start_date: filters.selExpCloserDateFrom || "",
        expctd_closure_end_date: filters.selExpCloserDateTo || "",
        threeday_assign_from: filters.selPtTrialAssignedDateFrom || "",
        threeday_assign_to: filters.selPtTrialAssignedDateTo || "",
        payment_location: filters.selectedPaymentLocation?.value || "",
        pt_initiated_date_from: filters.selPtInitiatedDateFrom || "",
        pt_initiated_date_to: filters.selPtInitiatedDateTo || "",
        bca_report_status: filters.bcaReportStatus?.value || "",
        three_day_done_count: filters.threeDayDoneCount?.value || "",
        three_day_done_from: filters.selThreeDayDoneDateFrom || "",
        three_day_done_to: filters.selThreeDayDoneDateTo || "",
        is_future_subscription: filters.isFutureSubscription || false,
        future_trial: toggle ? 1 : 0,
      };

      setSendableFilters(newSendableFilters);
      setAllPTReportsData((prevs) => ({ ...prevs, isPage: 0 }));
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    filters.selectedGym,
    filters.selectedTrainer,
    filters.selectedSubsAddedBy,
    filters.selectedReceptionist,
    filters.selectedPTTrialStatus,
    filters.selProspectStatus,
    filters.selectedHandoverStatus,
    filters.handoverCompletedOn,
    filters.trialCompletedOn,
    filters.lastCheckedIn,
    filters.lastWorkoutDaysAgo,
    filters.isBiomaxRegister,
    filters.isFitnessProfile,
    filters.trainerRatingStatus,
    filters.selTrainerIntro,
    filters.selectedPTTrial,
    filters.selectedPTTrialStartStatus,
    filters.selectedConvertedStatus,
    last_checkin_start_end_time,
    filters.selBiomaxAppRegister,
    filters.selTrialAddedFrom,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    filters.selPtScheduleDateFrom,
    filters.selPtScheduleDateTo,
    filters.selExpCloserDateFrom,
    filters.selExpCloserDateTo,
    filters.selPtTrialAssignedDateFrom,
    filters.selPtTrialAssignedDateTo,
    filters.selectedPaymentLocation,
    filters.selPtInitiatedDateFrom,
    filters.selPtInitiatedDateTo,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    filters.bcaReportStatus,
    filters.threeDayDoneCount,
    filters.selThreeDayDoneDateFrom,
    filters.selThreeDayDoneDateTo,
    filters.isFutureSubscription,
    filters.selPTProspect,
    toggle,
    last_checkin_start_end_time,
  ]);

  useEffect(() => {
    setSendableFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    const newAllFilters = {
      is_export: 1,
      ...sendableFilters,
      future_trial: toggle ? 1 : 0,
    };

    const currentFilters = JSON.stringify(newAllFilters);
    const previousFilters = JSON.stringify(allFilters);

    if (currentFilters !== previousFilters) {
      setAllFilters(newAllFilters);
    }
  }, [sendableFilters, toggle, allFilters]);

  useEffect(() => {
    const hasRequiredFilters = isOpen
      ? isTrainer
        ? sendableFilters.assigned_to
        : sendableFilters.gym_id
      : true;

    if (hasRequiredFilters && Object.keys(sendableFilters).length > 0) {
      if (!isInitialized) {
        setIsInitialized(true);
        getPtReportsData(sendableFilters);
      } else {
        const currentFilters = JSON.stringify(sendableFilters);
        const previousFilters = JSON.stringify(allFilters);

        if (currentFilters !== previousFilters) {
          getPtReportsData(sendableFilters);
        }
      }
    }
  }, [sendableFilters, isOpen, isTrainer, isInitialized, allFilters]);

  useEffect(() => {
    if (filters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setAllPTReportsData((prevs) => ({ ...prevs, isPage: 0 }));
      setSendableFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [filters.searchString]);

  useEffect(() => {
    if (
      !ptReportsLoading &&
      !ptReportError &&
      ptReportsData?.status &&
      ptReportsData?.data?.length > 0
    ) {
      const { data, pagination } = ptReportsData || {};

      setAllPTReportsData((prevs) => ({
        ...prevs,
        allPTReports: data,
        pagination: pagination,
      }));
    } else if (ptReportError || ptReportsData?.status === false) {
      setAllPTReportsData(iniPTReports);
    }
  }, [ptReportsLoading, ptReportsData, ptReportError]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    } else {
      setCsvData();
    }
  }, [exportData]);

  useEffect(() => {
    return () => {
      setActivePopover(null);
      setSelectedRows([]);
      setIsAllSelected(false);
      setIsInitialized(false);
    };
  }, []);

  useEffect(() => {
    setIsInitialized(false);
  }, [isOpen, decryptedText?.gym_id, decryptedText?.uid]);

  const tbColumns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="tb-buttons">
          {row?.is_future_subscription ? (
            <FutureSubscriptionButton row={row} />
          ) : (
            <>
              <button
                className="icon-btn edit"
                onClick={(e) =>
                  (row?.trial_status === "completed" ||
                    row?.trial_status === "converted" ||
                    row?.trial_status?.includes("cnvrtd")) &&
                  (isTrainer || isAdmin || isFitnessManager)
                    ? onClickBtns(e, "edit-pt-trial", row, "pt_trial")
                    : row?.handover_status === "completed" &&
                      (isReceptionist || isAdmin || isFitnessManager)
                    ? onClickBtns(e, "edit-handover", row, "handover")
                    : null
                }
                disabled={
                  (row?.trial_status !== "completed" ||
                    row?.trial_status !== "converted") &&
                  row?.handover_status !== "completed"
                }
                style={{
                  cursor:
                    row?.trial_status === "completed" ||
                    row?.trial_status === "converted" ||
                    row?.handover_status === "completed"
                      ? "pointer"
                      : "not-allowed",
                }}
              >
                <EditIcon1
                  color={
                    row?.trial_status === "pending" &&
                    row?.handover_status === "pending"
                      ? "gray"
                      : "#000"
                  }
                />
              </button>

              {isAdmin ? (
                <button
                  className="icon-btn delete"
                  onClick={(e) =>
                    row?.trial_status !== "pending" && handleDelete(e, row?.uid)
                  }
                  disabled={row?.trial_status === "pending"}
                  style={{
                    cursor:
                      row?.trial_status === "pending"
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  <BinIcon
                    color={row?.trial_status === "pending" ? "gray" : "#000"}
                  />
                </button>
              ) : null}

              {row?.handover_status === "pending" &&
              (isReceptionist || isAdmin || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initiate-handover", row)}
                >
                  Initiate Handover
                </button>
              ) : row?.handover_status !== "pending" &&
                row?.trial_status === "pending" &&
                (isTrainer || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initate-pt-trial", row)}
                >
                  Start PT Trial
                </button>
              ) : null}
            </>
          )}
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Member Details",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <div className="tb-flex-col">
            <span
              className="tb-data tb-link"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  rowData: row,
                  isModOpen: true,
                  name: "userDetailsModal",
                }))
              }
            >
              {row?.user_name?.replace(/_/g, " ") || "NA"}
            </span>
            <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
              {(!isReceptionist && row?.gym_name) || ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "three_day_assigned",
      text: "3 Day Assigned",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <div className="tb-data tb-icon">
            {row?.three_day_assigned === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </div>
        );
      },
    },
    sortableColumns[4],
    {
      dataField: "three_day_assigned",
      text: "3 day trial",
      formatter: (_, row) => {
        const startDate = row?.threeday_start_date
          ? formatDateTimezon(row.threeday_start_date)
          : "-";
        const endDate = row?.threeday_expire_date
          ? formatDateTimezon(row.threeday_expire_date)
          : "-";
        const startTime = row?.threeday_slot_start
          ? convertTo12HourFormat(row.threeday_slot_start)
          : "-";
        const endTime = row?.threeday_slot_end
          ? convertTo12HourFormat(row.threeday_slot_end)
          : "-";
        const sessions = row?.three_day_done_count || 0;

        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              Duration: {startDate} - {endDate}
            </span>

            <span className="tb-data">
              Slot: {startTime} - {endTime}
            </span>

            <div
              className="tb-flex"
              onClick={(e) => onClickBtns(e, "three-day-session", row)}
            >
              <span className="tb-data tb-icon">
                {row?.is_trial_done === true ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </span>

              <span className="tb-data tb-link underline">
                Completed Session: {sessions}
              </span>
            </div>
          </div>
        );
      },
    },

    sortableColumns[0],
    sortableColumns[1],
    {
      dataField: "assigned_by_name",
      text: "Handover By",
      formatter: (_, row) => {
        const shiftTimings = row?.assigned_by_shift?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-info-icon tb-link"
              onClick={(e) => handleInfoClick(row, "handover", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-handover`}
                onClose={() => setActivePopover(null)}
                title="Handover By"
                data={[
                  {
                    label: "Name",
                    value: row?.assigned_by_name || "NA",
                    fallback: "NA",
                    icon: <PersonIcon color="#2c3e50" />,
                  },
                  {
                    label: "Shift Time",
                    value: shiftTiming ? shiftTiming : "-",
                    fallback: "-",
                    icon: <ClockIcon color="#2c3e50" />,
                  },
                ]}
                position="bottom"
              />
            </span>

            <span className="tb-data tb-link">
              {row?.assigned_by_name || "NA"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "assigned_to_name",
      text: "Assigned To (Trainer)",
      formatter: (_, row) => {
        const shiftTimings = row?.assigned_to_shift?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-link tb-info-icon"
              onClick={(e) => handleInfoClick(row, "assigned", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-assigned`}
                onClose={() => setActivePopover(null)}
                title="Assigned To (Trainer)"
                data={[
                  {
                    label: "Name",
                    value: row?.assigned_to_name || "NA",
                    fallback: "NA",
                    icon: <PersonIcon color="#2c3e50" />,
                  },
                  {
                    label: "Shift Time",
                    value: shiftTiming ? shiftTiming : "-",
                    fallback: "-",
                    icon: <ClockIcon color="#2c3e50" />,
                  },
                ]}
                position="bottom"
              />
            </span>

            <span
              className="tb-data tb-link"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  name: "assignedMemModal",
                  assignToId: row?.assigned_to,
                  assignToName: row?.assigned_to_name,
                  shiftTime: shiftTiming,
                }))
              }
            >
              {row?.assigned_to_name || "NA"}
            </span>
          </div>
        );
      },
    },
    sortableColumns[2],
    sortableColumns[3],
    {
      dataField: "payment_location",
      text: "Payment Location",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row.payment_location === "gym"
              ? "Inside Gym"
              : row.payment_location === "outside"
              ? "Outside Gym"
              : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "handover_status",
    //   text: "Handover status",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data tb-icon">
    //         {row?.handover_status === "completed" ? (
    //           <CheckCircleIcon />
    //         ) : (
    //           <XCircleIcon />
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "trial_status",
    //   text: "trial status",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data tb-icon">
    //         {row?.is_trial_done === true ? (
    //           <CheckCircleIcon />
    //         ) : (
    //           <XCircleIcon />
    //         )}
    //       </span>
    //     );
    //   },
    // },

    {
      dataField: "biomax_first_step",
      text: "biomax first step (App Register)",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.biomax_first_step === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_biomax_registered",
      text: "Biomax Register",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.is_biomax_registered === "true" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_pt_prspct",
      text: "PT Prospect",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-info-icon"
              onClick={(e) => handleInfoClick(row, "prospect", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-prospect`}
                onClose={() => setActivePopover(null)}
                title="PT Prospect"
                data={[
                  {
                    label: row?.is_pt_prspct ? "Amount" : "Reason",
                    value: row?.is_pt_prspct
                      ? `₹${convertThenFormat(row?.prspct_value || 0)}`
                      : row?.pt_prspct_reason || "NA",
                    fallback: row?.is_pt_prspct ? "0" : "NA",
                    icon: row?.is_pt_prspct ? (
                      <RupeeIcon color="#2c3e50" />
                    ) : (
                      <AlertIcon color="#2c3e50" />
                    ),
                  },
                  ...(row?.is_pt_prspct
                    ? [
                        {
                          label: "PT Session",
                          value: row?.prspct_session || 0,
                          fallback: "-",
                          icon: <PersonIcon color="#2c3e50" />,
                        },
                        {
                          label: "PT Duration (Days)",
                          value: row?.prspct_duration || 0,
                          fallback: "-",
                          icon: <ClockIcon color="#2c3e50" />,
                        },
                        {
                          label: "Closure Date",
                          value: convertStraight(row?.expctd_closure_date),
                          fallback: "-",
                          icon: <DatePickerIcon color="#2c3e50" />,
                        },
                      ]
                    : []),
                ]}
                position="bottom"
              />
            </span>

            <span className="tb-data tb-icon">
              {row?.is_pt_prspct ? <CheckCircleIcon /> : <XCircleIcon />}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "isfitness_profile_completed",
      text: "fitness profile status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.isfitness_profile_completed === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    !isTrainer && {
      dataField: "trnr_intro_status",
      text: "Trainer Intro",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.trnr_intro_status === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "rating_id",
      text: "First Workout Trainer Rating",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.rating_id ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
  ];

  const tbColumnsTrainer = [
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="tb-buttons">
          {row?.is_future_subscription ? (
            <FutureSubscriptionButton row={row} />
          ) : (
            <>
              <button
                className="icon-btn edit"
                onClick={(e) =>
                  row?.trial_status !== "pending" && (isAdmin || isTrainer)
                    ? onClickBtns(e, "edit-pt-trial", row, "pt_trial")
                    : null
                }
                disabled={row?.trial_status === "pending"}
                style={{
                  cursor:
                    row?.trial_status === "pending" ? "not-allowed" : "pointer",
                }}
              >
                <EditIcon
                  color={
                    row?.trial_status === "pending" &&
                    row?.handover_status === "pending"
                      ? "gray"
                      : "#CD0909"
                  }
                />
              </button>

              {row?.handover_status !== "pending" &&
              row?.trial_status === "pending" &&
              (isTrainer || isAdmin || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initate-pt-trial", row)}
                >
                  Start PT Trial
                </button>
              ) : null}
            </>
          )}
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "User Profile",
      formatter: (_, row) => (
        <span
          className="tb-data tb-link"
          onClick={() =>
            setClickValues((prevs) => ({
              ...prevs,
              rowData: row,
              isModOpen: true,
              name: "userDetailsModal",
            }))
          }
        >
          {row?.user_name?.replace(/_/g, " ") || "NA"}
        </span>
      ),
    },
    sortableColumns[0],
    sortableColumns[1],
    {
      dataField: "assigned_by_name",
      text: "Handover By",
      formatter: (_, row) => {
        const shiftTimings = row?.assigned_by_shift?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-info-icon"
              onClick={(e) => handleInfoClick(row, "handover", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-handover`}
                onClose={() => setActivePopover(null)}
                title="Handover By"
                data={[
                  {
                    label: "Name",
                    value: row?.assigned_by_name || "NA",
                    fallback: "NA",
                    icon: <PersonIcon color="#2c3e50" />,
                  },
                  {
                    label: "Shift Time",
                    value: shiftTiming ? shiftTiming : "-",
                    fallback: "-",
                    icon: <ClockIcon color="#2c3e50" />,
                  },
                ]}
                position="bottom"
              />
            </span>

            <span className="tb-data">{row?.assigned_by_name || "NA"}</span>
          </div>
        );
      },
    },
    sortableColumns[3],
    {
      dataField: "three_day_assigned",
      text: "3 day trial",
      formatter: (_, row) => {
        const startDate = row?.threeday_start_date
          ? formatDateTimezon(row.threeday_start_date)
          : "-";
        const endDate = row?.threeday_expire_date
          ? formatDateTimezon(row.threeday_expire_date)
          : "-";
        const startTime = row?.threeday_slot_start
          ? convertTo12HourFormat(row.threeday_slot_start)
          : "-";
        const endTime = row?.threeday_slot_end
          ? convertTo12HourFormat(row.threeday_slot_end)
          : "-";
        const sessions = row?.three_day_done_count || 0;

        return (
          <div className="tb-flex">
            <p className="tb-data">
              <span style={{ display: "block" }}>
                Duration: {startDate} - {endDate}
              </span>
              <span style={{ display: "block" }}>
                Slot: {startTime} - {endTime}
              </span>
              <span
                style={{ display: "block" }}
                className="underline tb-link"
                onClick={(e) => onClickBtns(e, "three-day-session", row)}
              >
                Completed Session: {sessions}
              </span>
            </p>

            {/* <span
              className={`tb-data tb-link tb-icon`}
              onClick={(e) => onClickBtns(e, "three-day-session", row)}
            >
              {row?.three_day_assigned ? <CheckCircleIcon /> : <XCircleIcon />}
            </span> */}
          </div>
        );
      },
    },
    {
      dataField: "trial_status",
      text: "trial status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.is_trial_done === true ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    sortableColumns[4],
    {
      dataField: "is_pt_prspct",
      text: "PT Prospect",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-info-icon"
              onClick={(e) => handleInfoClick(row, "prospect", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-prospect`}
                onClose={() => setActivePopover(null)}
                title="PT Prospect"
                data={[
                  {
                    label: row?.is_pt_prspct ? "Amount" : "Reason",
                    value: row?.is_pt_prspct
                      ? `₹${convertThenFormat(row?.prspct_value || 0)}`
                      : row?.pt_prspct_reason || "NA",
                    fallback: row?.is_pt_prspct ? "0" : "NA",
                    icon: row?.is_pt_prspct ? (
                      <RupeeIcon color="#2c3e50" />
                    ) : (
                      <AlertIcon color="#2c3e50" />
                    ),
                  },
                  ...(row?.is_pt_prspct
                    ? [
                        {
                          label: "PT Session",
                          value: row?.prspct_session || 0,
                          fallback: "-",
                          icon: <PersonIcon color="#2c3e50" />,
                        },
                        {
                          label: "PT Duration (Days)",
                          value: row?.prspct_duration || 0,
                          fallback: "-",
                          icon: <ClockIcon color="#2c3e50" />,
                        },
                        {
                          label: "Closure Date",
                          value: convertStraight(row?.expctd_closure_date),
                          fallback: "-",
                          icon: <DatePickerIcon color="#2c3e50" />,
                        },
                      ]
                    : []),
                ]}
                position="bottom"
              />
            </span>

            <span className="tb-data tb-icon">
              {row?.is_pt_prspct ? <CheckCircleIcon /> : <XCircleIcon />}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "biomax_first_step",
      text: "biomax first step (App Register)",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.biomax_first_step === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_biomax_registered",
      text: "Biomax Register",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.is_biomax_registered === "true" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "isfitness_profile_completed",
      text: "fitness profile status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.isfitness_profile_completed === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "rating_id",
      text: "First Workout Trainer Rating",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.rating_id ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.name === "prospect_reason" ||
            clickValues.name === "three-day-session"
              ? "width50vw"
              : clickValues.name === "imageModal"
              ? "image-modal"
              : ""
          }`}
        >
          {clickValues.name === "exportModal" ? (
            <>
              <ModalHeader
                title={"Select Fields To Export"}
                onClick={onCloseModal}
              />
              <div>
                <SelectExportables
                  name={"pt-reports"}
                  exportableData={exportableData}
                  filters={allFilters}
                  setFilters={setAllFilters}
                  callFunction={onClickExport}
                  isLoadingCSV={exportLoading}
                  csvData={csvData}
                  setCsvData={setCsvData}
                />
              </div>
            </>
          ) : (
            <>
              <ModalHeadAndClose
                title={`${
                  clickValues.name === "prospect_reason"
                    ? "Reason For Non PT Prospect"
                    : clickValues.name === "userDetailsModal"
                    ? "Member Profile"
                    : clickValues.name === "imageModal"
                    ? clickValues.userName +
                      "/" +
                      clickValues.userNo +
                      "(" +
                      clickValues.gymName +
                      ")"
                    : clickValues.name === "assignedMemModal"
                    ? "Assigned Members Checked-in Logs between " +
                      clickValues.assignToName
                      ? clickValues.assignToName + "'s shift timing - "
                      : "trainer's shift timing -" + clickValues.shiftTime
                      ? clickValues.shiftTime
                      : ""
                    : clickValues.name === "workoutLogModal"
                    ? "Workout Logs"
                    : clickValues.name === "checkinLogsModal"
                    ? clickValues.type + " Checkin Logs"
                    : clickValues.name === "initiate-handover"
                    ? "Initiate Handover"
                    : clickValues.name === "initate-pt-trial"
                    ? "Register PT Trial"
                    : clickValues.name === "edit-pt-trial"
                    ? "Edit PT Trial Info"
                    : clickValues.name === "edit-handover"
                    ? "Edit Handover"
                    : clickValues.name === "three-day-session"
                    ? "Three Day Session Details"
                    : ""
                }`}
                onClose={onCloseModal}
              />

              {clickValues.name === "prospect_reason" ? (
                <div className="discussionModalMessage mt30">
                  <p className="message">
                    {clickValues.remarks || "No Content Available"}
                  </p>
                </div>
              ) : clickValues.name === "userDetailsModal" ? (
                <UserProfile userData={clickValues.rowData} isReport={true} />
              ) : clickValues.name === "imageModal" ? (
                <div className="discussionModalMessage maxWidth60vw maxHeight70vh mt30">
                  <img src={clickValues.viewImage} alt="profile" />
                </div>
              ) : clickValues.name === "exportModal" ? (
                <div>
                  <SelectExportables
                    name={"pt-reports"}
                    exportableData={exportableData}
                    filters={allFilters}
                    setFilters={setAllFilters}
                    callFunction={onClickExport}
                    isLoadingCSV={exportLoading}
                    csvData={csvData}
                    setCsvData={setCsvData}
                  />
                </div>
              ) : clickValues.name === "assignedMemModal" ? (
                <AssignedMembers
                  clickValues={clickValues}
                  sendableStatsQPs={prevFiltersQP}
                />
              ) : clickValues.name === "workoutLogModal" ? (
                <WorkoutLogs
                  clickValues={clickValues}
                  sendableStatsQPs={prevFiltersQP}
                />
              ) : clickValues.name === "checkinLogsModal" ? (
                <MemberCheckinLogs
                  clickValues={clickValues}
                  sendableStatsQPs={prevFiltersQP}
                  MCLDate={true}
                />
              ) : clickValues.name === "initiate-handover" ? (
                <ReceptionistForm
                  name={clickValues.name}
                  closeModal={onCloseModal}
                  decryptedText={decryptedText}
                  callFunction={() => {
                    getPtReportsData(sendableFilters);
                    callFunction();
                  }}
                  rowData={clickValues.rowData}
                  receptionistInfo={isAdmin ? iniAdminInfo : receptionistInfo}
                />
              ) : clickValues.name === "initate-pt-trial" ? (
                <PTTrialForm
                  name={"initiate-handover"}
                  trainerInfo={clickValues.trainerDetails}
                  closeModal={onCloseModal}
                  decryptedText={decryptedText}
                  callFunction={() => {
                    getPtReportsData(sendableFilters);
                    callFunction();
                  }}
                  rowData={clickValues.rowData}
                />
              ) : clickValues.name === "edit-pt-trial" ? (
                <PTTrialForm
                  closeModal={() => onCloseModal}
                  callFunction={() => {
                    getPtReportsData(sendableFilters);
                    callFunction();
                  }}
                  name={"edit"}
                  rowData={clickValues.rowData}
                  trainerInfo={clickValues.trainerDetails}
                  decryptedText={decryptedText}
                />
              ) : clickValues.name === "edit-handover" ? (
                <ReceptionistForm
                  name={"edit"}
                  closeModal={() => onCloseModal}
                  decryptedText={decryptedText}
                  callFunction={() => {
                    getPtReportsData(sendableFilters);
                    callFunction();
                  }}
                  rowData={clickValues.rowData}
                  receptionistInfo={isAdmin ? iniAdminInfo : receptionistInfo}
                />
              ) : clickValues.name === "three-day-session" ? (
                <TrainerSession
                  closeModal={() => onCloseModal}
                  sendableStatsQPs={prevFiltersQP}
                  rowData={clickValues.rowData}
                />
              ) : null}
            </>
          )}
        </div>
      </Modal>

      <PTTableFilters
        filters={filters}
        setFilters={setFilters}
        onClickSearch={onClickSearch}
        handleKeyPress={handleKeyPress}
        onClickReset={onClickReset}
        searchFilterApplied={searchFilterApplied}
        decryptedText={decryptedText}
        isPTReports={true}
        onClickExportBtn={() =>
          setClickValues({
            isModOpen: true,
            name: "exportModal",
          })
        }
        setSendableFilters={setSendableFilters}
        ptAdminDate={isOpen ? false : true}
        isLoading={ptReportsLoading}
        toggle={toggle}
        handleToggle={handleToggle}
        isReload={() => {
          getPtReportsData(sendableFilters);
        }}
      />

      {selectedRows?.length > 0 && (
        <div className="mt30">
          <BackAddBtns
            isRawLead={true}
            addBtnTxt={`${
              selectedRows?.length === 0
                ? "Select Rows From The Table"
                : "Trial Intro Done"
            }`}
            onClickAdd={onClickTrialDone}
            onClickReload={() => {
              callFunction();
              setSelectedRows([]);
              setIsAllSelected(false);
              setAllPTReportsData((prevState) => ({
                ...prevState,
                allPTReports: prevState.allPTReports.map((lead) => ({
                  ...lead,
                  checked: false,
                })),
              }));
            }}
            isAddBtn={true}
            isDiabled={selectedRows?.length === 0}
          />
        </div>
      )}

      <div className="common-table-container mt15 hideMobile">
        <CommonTable
          tableData={sortedData}
          tableColumns={isTrainer ? tbColumnsTrainer : tbColumns}
          tablePagination={pagination}
          isPage={isPage}
          setIsPage={(value) =>
            setAllPTReportsData((prevData) => ({
              ...prevData,
              isPage: value,
            }))
          }
          pageLimit={pageLimit}
          setPageLimit={(value) =>
            setAllPTReportsData((prevData) => ({
              ...prevData,
              pageLimit: value,
            }))
          }
          isLoading={ptReportsLoading}
        />
      </div>

      <div className="lead-logs-card-container pt-trial-tb-cards only-mobile">
        <PTTableCards
          isReport={true}
          tableData={allPTReportsData.allPTReports}
          setClickValues={setClickValues}
          tablePagination={pagination}
          isPage={isPage}
          setIsPage={(value) =>
            setAllPTReportsData((prevData) => ({
              ...prevData,
              isPage: value,
            }))
          }
          onClickBtns={onClickBtns}
          handleDelete={handleDelete}
          userInfoData={decryptedText}
        />
      </div>
    </>
  );
};

export default PTReports;
